<div *ngIf="canLoggedInUserFollowTargetPublicKey()">
  <div *ngIf="displayAsLink; else displayAsLinkElseBlock">
    <div [ngClass]="creatorCoinTemplate ? 'my-2' : ''">
      <div class="mobile-creator-coin-info mr-2" *ngIf="creatorCoinTemplate">
        <ng-container *ngTemplateOutlet="creatorCoinTemplate"></ng-container>
      </div>
      <div
        [ngClass]="creatorCoinTemplate ? 'd-inline-block' : ''"
        *ngIf="createFollowTxnBeingCalled; else beingCalledElseBlock"
      >
        <!-- Loading-->
        <div class="spinner-border text-secondary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <ng-template #beingCalledElseBlock>
        <!-- Actual link-->
        <div
          [ngClass]="creatorCoinTemplate ? 'd-inline-block' : ''"
          *ngIf="isFollowing; else isFollowingElseBlock"
        >
          <a class="" [ngClass]="followLinkClass" (click)="unfollow($event)"
            >Unfollow</a
          >
        </div>
        <ng-template #isFollowingElseBlock>
          <a class="" [ngClass]="followLinkClass" (click)="follow($event)"
            >Follow</a
          >
        </ng-template>
      </ng-template>
    </div>
    <!-- Display as link-->
  </div>
  <ng-template #displayAsLinkElseBlock>
    <!-- Display as button -->
    <div *ngIf="isFollowing; else elseBlock">
      <button [ngClass]="getUnfollowButtonClasses()" (click)="unfollow($event)">
        Unfollow
      </button>
    </div>
    <ng-template #elseBlock>
      <button [ngClass]="getFollowButtonClasses()" (click)="follow($event)">
        Follow
      </button>
    </ng-template>
  </ng-template>
</div>
